import { inject, Pipe, PipeTransform } from '@angular/core';
import { Nullable } from 'primeng/ts-helpers';
import { LatLon } from '../../../contract/lat-lon.contract';
import { MapUtilsService } from '../services/map-utils.service';

@Pipe({
  name: 'locationToLatLngLiteral',
  standalone: true,
})
export class LocationToLatLngLiteralPipe implements PipeTransform {
  private mapUtilsService = inject(MapUtilsService);

  public transform(location: LatLon | Nullable): google.maps.LatLngLiteral | null {
    return this.mapUtilsService.locationToLatLngLiteral(location);
  }
}
